import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';


import { fetchDataActive, postData, fetchData, updateData, fetchData1, deleteData1 } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { TableCell, Modal, TableContainer, Tooltip, Paper, Table, TablePagination, TableHead, TableBody, TableRow } from '@mui/material';


import {
  Search as SearchIcon,


  Edit as EditIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';


const BranchEdit = (props) => {
  const history = useHistory();
  const { isAuthenticated, clubId, branchId, userId, logout, token } = useAuth();
  const { id } = useParams();
  const [branchcode, setBranchCode] = useState("");
  const [branchname, setBranchName] = useState("");
  const [no1, setContactNo1] = useState("");
  const [no2, setContactNo2] = useState("");
  const [no3, setContactNo3] = useState("");
  const [email, setEmail] = useState("");
  const [addressline1, setAddressLine1] = useState("");
  const [addressline2, setAddressLine2] = useState("");
  const [gstno, setGstNo] = useState("");
  const [panno, setPanNo] = useState("");
  const [location, setLocation] = useState("");
  const [pincode, setPinCode] = useState("");
  const [cashopening, setCashOpening] = useState("");
  const [stockopening, setStockOpening] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSave, setIsSave] = useState(false);
  const [ClubChildDatas, setClubChildDatas] = useState([]);
  const [InteractClubDatas, setInteractClubDatas] = useState([]);
  const [RoteractClubDatas, setRoteractClubDatas] = useState([]);
  // const [filteredData, setFilteredData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [istatus, setInteractStatus] = useState(true);
  const [rstatus, setRoteractStatus] = useState(true);
  const [name, setPersonName] = useState("");
  const [opening, setOpening] = useState(0);
  const [address, setAddress] = useState("");
  const [branch, setBranch] = useState("");
  const [accountno, setAccountNo] = useState("");
  const [ifsc, setIFSC] = useState("");
  const [email1, setEmail1] = useState("");
  const [phone, setPhonenumber] = useState("");
  const [isbanklist, setIsBankList] = useState(false);
  const [isBank, setIsBank] = useState(false);
  //const [selectedValue, setSelectedValue] = useState("1");
  //-------------------------------------------for edit-------------------
  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false); // For editing
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState(null); // Holds the person data when editing
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [deletedata, setDeletedata] = useState(null); // To store the ID of the item to delete
  const [clubassociates, setClubAssociteOptions] = useState([]);
  const [selectedassociate, SetSelectedAssociate] = useState("");
  const [data, setData] = useState([]);

   const [selectedMember, setSelectedMember] = useState(""); 
	 const [memberid, setMemberId] = useState("");
	 const [searchTerm, setSearchTerm] = useState('');


  let financialYear;
  const [formData, setFormData] = useState({
    name: '',
    branchCode: '',
    district: '',
    charterDate: '',
    idNo: '',
    email: '',
    clubId: '',
    meetingDay: '',
    meetingLoc: '',
    meetingTime: '',
    sponsoredBy: '',
    location: '',
    postalAddress: '',
    cashOpening: '',
    website: '',
    instaLink: '',
    faceBookLink: '',
    createdBy: '',
    createdDate: '',
    updatedBy: '',
    updatedDate: '',
    sposoredClubName: '',
    actualMeetingTime: '',
    meetingDay1: '',

  });
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedInteractRecord, setSelectedInteractRecord] = useState(null);
  const [selectedRoteractRecord, setSelectedRoteractRecord] = useState(null);
   const [ispersonModalOpen, setPersonModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [officialsModalOpen, setOfficialsModalOpen] = useState(false);
  const [interactModalOpen, setInteractModalOpen] = useState(false);
  const [rotaractModalOpen, setRotaractModalOpen] = useState(false);
  const [clubsModalOpen, setClubsModalOpen] = useState(false);

  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('PurchaseOrderDate');
  const openModal = () => setIsModalOpen(true);
    const closeModal = () => setPersonModalOpen(false);
  useEffect(() => {
    fetchMember();
    fetchPositions();
    calculateFinancialYear();
    fetchtableData();
    fetchtableData1();


  }, []);
  function calculateFinancialYear() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();


    // Assuming the financial year starts in April (month 3)
    if (currentMonth >= 3) {
      financialYear = `${currentYear}-${currentYear + 1}`;  // Example: "2024-2025"
    } else {
      financialYear = `${currentYear - 1}-${currentYear}`;  // Example: "2023-2024"
    }
  }

  const optionsn = [
    { value: 1, label: 'Payable' },
    { value: 2, label: 'Receivable' },


  ];
  const [selectedValue, setSelectedValue] = useState(optionsn[0]);
  const [newRoteractData, setNewRoteractData] = useState({
    id: '',
    name: '',
    address: '',
    status: '',
    status1: '',
    isActive: '',
    isInteract: false,
  });
  const [newInteractData, setNewInteractData] = useState({
    id: '',
    name: '',
    address: '',
    status: '',
    status1: '',
    isActive: '',
    isInteract: true,
  });

  const [newRecordData, setNewRecordData] = useState({
    id: '',
    memberId: '',
    name: '',
    userTypeId: '',
    toDate: '',
    fromDate: '',
    isActive: ''
  });
  const handleInputChange = (event) => {
    const { name, type, checked, value } = event.target;

    setNewInteractData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value, // Correctly handle checkboxes
    }));
  };

  const handleInputChange1 = (event) => {
    const { name, type, checked, value } = event.target;

    setNewRoteractData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value, // Correctly handle checkboxes
    }));
  };
  const fetchtableData1 = async () => {
    fetchData('ClubAssociatesTypes', `/${clubId}/${branchId}`, token)
      .then((response) => {

        if (response.responseCode === '1111') {

          const options = response.response_data.map(group => ({
            value: group.Id,
            label: group.ClubAssociateType

          }));
          setClubAssociteOptions(options);

        } else {
          console.warn("Expected an array but got:", response.response_data);
          setClubAssociteOptions([]); // fallback to an empty array to prevent breaking
        }
      })
      .catch((error) => {
        console.error('Error fetching Club Associates Types Details:', error);
      });
  };
  const toggleModal = (recorddata = null) => {
    if (recorddata && recorddata.id !== null && recorddata.id !== undefined) {
      // Open modal for editing an existing record
      
    setSelectedRecord(recorddata);
      setNewRecordData({
        id_: recorddata.id,
        userTypeId: recorddata.userTypeId,
        name:recorddata.memberName,
        memberId: recorddata.memberId,
        fromDate: recorddata.fromDate,
        toDate: recorddata.toDate,
        isActive: recorddata.isActive,
      });
      
    } else {
      // Open modal for adding a new record (when recorddata is null or MemberId is null)
      setSelectedRecord(null);
      setNewRecordData({
        userTypeId: '', memberId: '', toDate: '',
        fromDate: ''
      }); // Ensure it's empty for adding new records
    }
    setIsModalOpen(true); // Open the modal
  };
  const toggleCloseModal = (recorddata = null) => {
    setOfficialsModalOpen(false);
  };
  const toggleClubOfficialsModal = (recorddata = null) => {
    setOfficialsModalOpen(true);
  };

  const toggleInteractModal1 = (recorddata = null) => {
    setInteractModalOpen(true);
  };

  const toggleRoteractModal1 = (recorddata = null) => {
    setRotaractModalOpen(true);
  };

  const toggleClubsModal1 = (recorddata = null) => {
    setClubsModalOpen(true);
  };
  const toggleEditModalClose = (recorddata = null) => {
    fetchtableData();
    setClubsModalOpen(true);
    setIsModalOpenEdit(false);
  };
  const toggleCluModalClose = (recorddata = null) => {
    setClubsModalOpen(false);
  };



  const toggleInteractModal = (recorddata = null) => {
    if (recorddata && recorddata.id !== null && recorddata.id !== undefined) {
      // Open modal for editing an existing record
      setClubsModalOpen(true); // Open the modal
      setSelectedInteractRecord(recorddata);
      setNewInteractData({
        id: recorddata.id,
        name: recorddata.name,
        address: recorddata.address,
        status: recorddata.status,
        status1: recorddata.status1,
        isActive: true,
        isInteract: true,
      });
    } else {
      // Open modal for adding a new record (when recorddata is null or MemberId is null)
      setSelectedInteractRecord(null);
      setNewInteractData({ id: '', name: '', address: '', status: '', status1: '', isActive: '', isInteract: true }); // Ensure it's empty for adding new records
    }
    // setIsModalOpen1(true); // Open the modal
  };
  const handleEdit = (id) => {
    fetchData('PersonApi', `/GetPersonDetails/${id}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          const data = response.response_data;
          setEditData(data); // Store fetched data in state
          setPersonName(data.name || '');
          setOpening(data.opening || 0);
          setBranch(data.branch || '');
          setAddress(data.address || '');
          setPhonenumber(data.phoneNumber || '');
          setAccountNo(data.accountNo || '');
          setIFSC(data.ifsc || '');
          setEmail1(data.email || '');
          //setSelectedValue(data.selectedValue || '1');
          setIsBank(data.isBank || false);
          setIsEditing(true); // Set editing mode
          SetSelectedAssociate(data.associateTypeId || ''); // Set the selected associate type

          const selectedAssociateOption = clubassociates.find(opt => opt.value === data.associateTypeId);
          SetSelectedAssociate(selectedAssociateOption || null);
          const selectedPaymentOption = optionsn.find(opt => opt.value === data.paymentType);
          setSelectedValue(selectedPaymentOption || null);
          toggleModalEdit();
        } else {
          console.error('Error fetching person details');
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  };




  const fetchtableData = async () => {
    fetchData('PersonApi', `/${branchId}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          setData(response.response_data);

        }
      })
      .catch((error) => {
        console.error('Error fetching Persons Details:', error);
        // Handle error, e.g., redirect to login if token is expired
        if (error.response && error.response.status === 401) {
          logout();
          // Redirect to login with the current location as a parameter
          history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
        }
      });
  };

  const toggleRoteractModal = (recorddata = null) => {
    if (recorddata && recorddata.id !== null && recorddata.id !== undefined) {
      // Open modal for editing an existing record
      setSelectedRoteractRecord(recorddata);
      setNewRoteractData({
        id: recorddata.id,
        name: recorddata.name,
        address: recorddata.address,
        status: recorddata.status,
        status1: recorddata.status1,
        isActive: true,
        isInteract: false,
      });
    } else {
      // Open modal for adding a new record (when recorddata is null or MemberId is null)
      setSelectedRoteractRecord(null);

      setNewRoteractData({ id: '', name: '', address: '', status: '', status1: '', isActive: '', isInteract: false });
    }
    setIsModalOpenEdit(true); // Open the modal
  };






  const [memberlist, setMemberOptions] = useState([]);
  const [positionlist, setPositionsOptions] = useState([]);


  const fetchMember = async () => {
    try {
      const params1 = `/${clubId}`;
      const params2 = `?branchId=${id}`;
      // const response = await fetchData1('MemberApi', params1, params2, token);
      const response = await fetchData1('MemberApi', `/${clubId}/${id}`, token);
      if (response.responseCode === '1111') {


        const options = response.response_data.map(member => ({
          value: member.id,
          label: member.firstName,


        }));
        setMemberOptions(response.response_data);
      }
    } catch (error) {
      console.error('Error fetching Member:', error);
    }
  };

  const handlePositionSelectChange = (selectedOption) => {
    setNewRecordData({ ...newRecordData, userTypeId: selectedOption.value });
  };

  const handleMemberSelectChange = (selectedOption) => {
    setNewRecordData({ ...newRecordData, memberId: selectedOption.value });
  };

  const handleDateChange = (event) => {
    setNewRecordData({ ...newRecordData, toDate: event.target.value });
  };

  const handleDateChange1 = (event) => {
    setNewRecordData({ ...newRecordData, fromDate: event.target.value });
  };



  const addOrEditRecord = (e, mode) => {
    e.preventDefault();
    if (mode === 'add') {
      const isSameMemberAndPositionExists = ClubChildDatas.some((data) => {
        // const isSameMember = String(data.memberId) === String(newRecordData.memberId);
        const isSamePosition = String(data.userTypeId) === String(newRecordData.userTypeId);
        return isSamePosition; // Block if both member and position match
      });

      if (isSameMemberAndPositionExists) {
        alert("This position already Exist.");
        return;

      };
    }

    const branch = {
      Id: formData.id,
      BranchCode: formData.branchCode || "", // empty string instead of null
      Name: formData.name || "",
      District: formData.district || "",
      CharterDate: formData.charterDate || "",
      IdNo: formData.idNo, // 0 instead of null for numbers
      Email: formData.email || "",
      MeetingDay: null,
      MeetingDay1: formData.meetingDay1 || "",
      meetingLoc: formData.meetingLoc || "",
      MeetingTime: null,
      ActualMeetingTime: formData.actualMeetingTime || "",
      SponsoredBy: formData.sponsoredBy || "",
      Location: formData.location || "",
      PostalAddress: formData.postalAddress || "",
      CashOpening: formData.cashOpening || 0, // 0 instead of null for numbers
      Website: formData.website || "",
      InstaLink: formData.instaLink || "",
      FaceBookLink: formData.faceBookLink || "",
      ClubId: clubId || "",
      SposoredClub: formData.sposoredClubName || "",
      UpdatedBy: userId || "",
      UpdatedDate: new Date(),
    };
    let newid = newRecordData.id || 0;
    if (selectedRecord) {
      newid = selectedRecord.id || 0;
    }
    const childdata = [{
      Id: newid || 0,
      ClubId: clubId,
      BranchId: formData.id,
      MemberId: newRecordData.memberId,
      FromDate: newRecordData.fromDate,
      ToDate: newRecordData.toDate,
      UserTypeId: newRecordData.userTypeId || null,
      CreatedBy: newRecordData.createdBy || userId,
      CreatedDate: newRecordData.createdDate || new Date(),  // Conditionally set CreatedDate
      ModifiedBy: newRecordData.ModifiedBy || userId,
      ModifiedDate: newRecordData.ModifiedDate || new Date(),
      IsActive: true,
      FinancialYear: financialYear,
    }];

    const InteractAndRoteractClubDatas1 = InteractClubDatas.map(childdata => ({
      Id: childdata.id,
      ClubId: clubId,
      BranchId: formData.id,
      Name: childdata.name,
      Address: childdata.address,
      Status: childdata.status,
      Status1: childdata.status1,
      IsInteract: childdata.isInteract,
      CreatedBy: childdata.Id === 0 ? userId : childdata.createdBy,  // Conditionally set CreatedBy
      CreatedDate: childdata.Id === 0 ? new Date() : childdata.createdDate,  // Conditionally set CreatedDate
      ModifiedBy: childdata.Id === 0 ? userId : childdata.ModifiedBy,
      ModifiedDate: childdata.Id === 0 ? new Date() : childdata.ModifiedDate,
      IsActive: childdata.status1,
    }));

    const RoteractClubDatas1 = RoteractClubDatas.map(childdata => ({
      Id: childdata.id || 0,
      ClubId: clubId,
      BranchId: formData.id,
      Name: childdata.name,
      Address: childdata.address,
      Status: childdata.status,
      Status1: true,
      IsInteract: childdata.isInteract,
      CreatedBy: userId,
      CreatedDate: new Date(),
      IsActive: true,
    }));

    const InteractAndRoteractClubDatasList1 = [
      ...InteractAndRoteractClubDatas1,
      ...RoteractClubDatas1
    ];

    const BranchAndChilds = {
      BranchData: branch,
      ChapterOfficialsData: childdata,
      InteractAndRoteractClubDatasList: InteractAndRoteractClubDatasList1,
    };

    try {
      const response = updateData('BranchChild', id, BranchAndChilds, token);
      //const response = await postData('BranchApi', branch, token);
      console.log('Branch Updated success:', response);
      setSuccessMessage("Branch  Updated successfully!");
      setErrorMessage("");
      clearForm();

      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);


    } catch (error) {
      console.error('Branch Create error:', error);


    };
    window.location.reload();
    setSelectedInteractRecord(null);
    setIsModalOpen1(false);
    setOfficialsModalOpen(false)
    setIsModalOpen(false); // Close the modal
  };

  const addOrEditRecordNew = (e) => {
    e.preventDefault();
    submitData(e);
    //setIsModalOpen(false); 
    setIsModalOpen1(false);// Close the modal
  };

  const addOrEditRecord1 = () => {

    const branch = {
      Id: formData.id,
      BranchCode: formData.branchCode || "", // empty string instead of null
      Name: formData.name || "",
      District: formData.district || "",
      CharterDate: formData.charterDate || "",
      IdNo: formData.idNo, // 0 instead of null for numbers
      Email: formData.email || "",
      MeetingDay: null,
      MeetingDay1: formData.meetingDay1 || "",
      meetingLoc: formData.meetingLoc || "",
      MeetingTime: null,
      ActualMeetingTime: formData.actualMeetingTime || "",
      SponsoredBy: formData.sponsoredBy || "",
      Location: formData.location || "",
      PostalAddress: formData.postalAddress || "",
      CashOpening: formData.cashOpening || 0, // 0 instead of null for numbers
      Website: formData.website || "",
      InstaLink: formData.instaLink || "",
      FaceBookLink: formData.faceBookLink || "",
      ClubId: clubId || "",
      SposoredClub: formData.sposoredClubName || "",
      UpdatedBy: userId || "",
      UpdatedDate: new Date(),
    };

    const childdata = ClubChildDatas.map(childdata => ({
      Id: childdata.id || 0,
      ClubId: clubId,
      BranchId: formData.id,
      MemberId: childdata.memberId,
      FromDate: childdata.fromDate,
      ToDate: childdata.toDate,
      UserTypeId: childdata.userTypeId || null,
      CreatedBy: childdata.Id === 0 ? userId : childdata.createdBy,  // Conditionally set CreatedBy
      CreatedDate: childdata.Id === 0 ? new Date() : childdata.createdDate,  // Conditionally set CreatedDate
      ModifiedBy: childdata.Id === 0 ? userId : childdata.ModifiedBy,
      ModifiedDate: childdata.Id === 0 ? new Date() : childdata.ModifiedDate,
      IsActive: true,
      FinancialYear: financialYear,
    }));

    const InteractAndRoteractClubDatas1 = [{
      Id: newInteractData.id || 0,
      ClubId: clubId,
      BranchId: formData.id,
      Name: newInteractData.name,
      Address: newInteractData.address,
      Status: newInteractData.status,
      Status1: true,
      IsInteract: true,
      CreatedBy: userId,
      CreatedDate: new Date(),
      IsActive: true,
    }];

    const RoteractClubDatas1 = RoteractClubDatas.map(childdata => ({
      Id: childdata.id || 0,
      ClubId: clubId,
      BranchId: formData.id,
      Name: childdata.name,
      Address: childdata.address,
      Status: childdata.status,
      Status1: true,
      IsInteract: childdata.isInteract,
      CreatedBy: userId,
      CreatedDate: new Date(),
      IsActive: true,
    }));

    const InteractAndRoteractClubDatasList1 = [
      ...InteractAndRoteractClubDatas1,
      ...RoteractClubDatas1
    ];

    const BranchAndChilds = {
      BranchData: branch,
      ChapterOfficialsData: childdata,
      InteractAndRoteractClubDatasList: InteractAndRoteractClubDatasList1,
    };

    try {
      const response = updateData('BranchChild', id, BranchAndChilds, token);
      //const response = await postData('BranchApi', branch, token);
      console.log('Branch Updated success:', response);
      setSuccessMessage("Branch  Updated successfully!");
      setErrorMessage("");
      clearForm();
      window.location.reload();
      fetchTableDataBranch();
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);


    } catch (error) {
      console.error('Branch Create error:', error);
    }

    setSelectedInteractRecord(null);
    setIsModalOpen1(false);
  };



  const addOrEditRecord2 = () => {

    const branch = {
      Id: formData.id,
      BranchCode: formData.branchCode || "", // empty string instead of null
      Name: formData.name || "",
      District: formData.district || "",
      CharterDate: formData.charterDate || "",
      IdNo: formData.idNo, // 0 instead of null for numbers
      Email: formData.email || "",
      MeetingDay: null,
      MeetingDay1: formData.meetingDay1 || "",
      meetingLoc: formData.meetingLoc || "",
      MeetingTime: null,
      ActualMeetingTime: formData.actualMeetingTime || "",
      SponsoredBy: formData.sponsoredBy || "",
      Location: formData.location || "",
      PostalAddress: formData.postalAddress || "",
      CashOpening: formData.cashOpening || 0, // 0 instead of null for numbers
      Website: formData.website || "",
      InstaLink: formData.instaLink || "",
      FaceBookLink: formData.faceBookLink || "",
      ClubId: clubId || "",
      SposoredClub: formData.sposoredClubName || "",
      UpdatedBy: userId || "",
      UpdatedDate: new Date(),
    };

    const childdata = ClubChildDatas.map(childdata => ({
      Id: childdata.id || 0,
      ClubId: clubId,
      BranchId: formData.id,
      MemberId: childdata.memberId,
      FromDate: childdata.fromDate,
      ToDate: childdata.toDate,
      UserTypeId: childdata.userTypeId || null,
      CreatedBy: childdata.Id === 0 ? userId : childdata.createdBy,  // Conditionally set CreatedBy
      CreatedDate: childdata.Id === 0 ? new Date() : childdata.createdDate,  // Conditionally set CreatedDate
      ModifiedBy: childdata.Id === 0 ? userId : childdata.ModifiedBy,
      ModifiedDate: childdata.Id === 0 ? new Date() : childdata.ModifiedDate,
      IsActive: true,
      FinancialYear: financialYear,
    }));

    const InteractAndRoteractClubDatas1 = InteractClubDatas.map(childdata => ({
      Id: childdata.id,
      ClubId: clubId,
      BranchId: formData.id,
      Name: childdata.name,
      Address: childdata.address,
      Status: childdata.status,
      Status1: childdata.status1,
      IsInteract: childdata.isInteract,
      CreatedBy: childdata.Id === 0 ? userId : childdata.createdBy,  // Conditionally set CreatedBy
      CreatedDate: childdata.Id === 0 ? new Date() : childdata.createdDate,  // Conditionally set CreatedDate
      ModifiedBy: childdata.Id === 0 ? userId : childdata.ModifiedBy,
      ModifiedDate: childdata.Id === 0 ? new Date() : childdata.ModifiedDate,
      IsActive: childdata.status1,
    }));

    const RoteractClubDatas1 = [{
      Id: newRoteractData.id || 0,
      ClubId: clubId,
      BranchId: formData.id,
      Name: newRoteractData.name,
      Address: newRoteractData.address,
      Status: newRoteractData.status,
      Status1: true,
      IsInteract: false,
      CreatedBy: userId,
      CreatedDate: new Date(),
      IsActive: true,
    }];

    const InteractAndRoteractClubDatasList1 = [
      ...InteractAndRoteractClubDatas1,
      ...RoteractClubDatas1
    ];

    const BranchAndChilds = {
      BranchData: branch,
      ChapterOfficialsData: childdata,
      InteractAndRoteractClubDatasList: InteractAndRoteractClubDatasList1,
    };

    try {
      const response = updateData('BranchChild', id, BranchAndChilds, token);
      //const response = await postData('BranchApi', branch, token);
      console.log('Branch Updated success:', response);
      setSuccessMessage("Branch  Updated successfully!");
      setErrorMessage("");
      clearForm();
      window.location.reload();
      fetchTableDataBranch();
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
      // 

    }
    catch (error) {
      console.error('Branch Create error:', error);
    }
    setSelectedInteractRecord(null);
    setIsModalOpen2(false);
    toggleRoteractModal1();
  };
  // Open Edit Modal
  const openEditModal = (record) => {
    setSelectedInteractRecord(record);
    setNewInteractData(record);
    setIsModalOpen1(true);
  };

  const fetchPositions = async () => {
    try {
      const response = await fetchData('UserTypesApi', `/${clubId}`, token)
      if (response.responseCode === '1111') {


        const options = response.response_data.map(usertypes => ({
          value: usertypes.Id,
          label: usertypes.Name,


        }));
        setPositionsOptions(options);
      }
    } catch (error) {
      console.error('Error fetching User Types:', error);
    }
  };


  const clearForm = () => {
    // setEventName(""); setFromDate("");
    // setToDate(""); setDescription("");
    // setVenue(""); setIncomeEstimate("");
    // setExpenseEstimate(""); setIncomeActual("");
    // setExpenseActual("");


  };

 const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setPersonModalOpen(true); // Open modal when typing in the search box
    };


       const handleRowClick = (member) => {
        const selectedOption = { value: member.id, label: `${member.firstName} ${member.lastName}` };
        setSelectedMember(selectedOption);
        setSearchTerm(selectedOption.label); // Display the selected name in the search box
        setPersonModalOpen(false); // Close modal after selecting a member
        setMemberId(selectedOption.value);
        setNewRecordData(prev => ({
    ...prev,
    memberId: selectedOption.value,
    name: selectedOption.label,
    
}));
    };

  const handleFormSubmit = (e) => {
    // e.preventDefault();
    setIsSubmit(true);
    submitData(e);


  }


  const submitData = async (e) => {
    // e.preventDefault();



    const branch = {
      Id: formData.id,
      BranchCode: formData.branchCode || "", // empty string instead of null
      Name: formData.name || "",
      District: formData.district || "",
      CharterDate: formData.charterDate || "",
      IdNo: formData.idNo, // 0 instead of null for numbers
      Email: formData.email || "",
      MeetingDay: null,
      MeetingDay1: formData.meetingDay1 || "",
      meetingLoc: formData.meetingLoc || "",
      MeetingTime: null,
      ActualMeetingTime: formData.actualMeetingTime || "",
      SponsoredBy: formData.sponsoredBy || "",
      Location: formData.location || "",
      PostalAddress: formData.postalAddress || "",
      CashOpening: formData.cashOpening || 0, // 0 instead of null for numbers
      Website: formData.website || "",
      InstaLink: formData.instaLink || "",
      FaceBookLink: formData.faceBookLink || "",
      ClubId: clubId || "",
      SposoredClub: formData.sposoredClubName || "",
      UpdatedBy: userId || "",
      UpdatedDate: new Date(),
    };
    const childdata = ClubChildDatas.map(childdata => ({
      Id: childdata.id,
      ClubId: clubId,
      BranchId: formData.id,
      MemberId: childdata.memberId,
      FromDate: childdata.fromDate,
      ToDate: childdata.toDate,
      UserTypeId: childdata.userTypeId || null,
      CreatedBy: childdata.Id === 0 ? userId : childdata.createdBy,  // Conditionally set CreatedBy
      CreatedDate: childdata.Id === 0 ? new Date() : childdata.createdDate,  // Conditionally set CreatedDate
      ModifiedBy: childdata.Id === 0 ? userId : childdata.ModifiedBy,
      ModifiedDate: childdata.Id === 0 ? new Date() : childdata.ModifiedDate,
      IsActive: true,
      FinancialYear: financialYear,
    }));

    const InteractAndRoteractClubDatas1 = InteractClubDatas.map(childdata => ({
      Id: childdata.id,
      ClubId: clubId,
      BranchId: formData.id,
      Name: childdata.name,
      Address: childdata.address,
      Status: childdata.status,
      Status1: childdata.status1,
      IsInteract: childdata.isInteract,
      CreatedBy: childdata.Id === 0 ? userId : childdata.createdBy,  // Conditionally set CreatedBy
      CreatedDate: childdata.Id === 0 ? new Date() : childdata.createdDate,  // Conditionally set CreatedDate
      ModifiedBy: childdata.Id === 0 ? userId : childdata.ModifiedBy,
      ModifiedDate: childdata.Id === 0 ? new Date() : childdata.ModifiedDate,
      IsActive: childdata.status1,
    }));
    const RoteractClubDatas1 = RoteractClubDatas.map(childdata => ({
      Id: childdata.id,
      ClubId: clubId,
      BranchId: formData.id,
      Name: childdata.name,
      Address: childdata.address,
      Status: childdata.status,
      Status1: childdata.status1,
      IsInteract: childdata.isInteract,
      CreatedBy: childdata.Id === 0 ? userId : childdata.createdBy,  // Conditionally set CreatedBy
      CreatedDate: childdata.Id === 0 ? new Date() : childdata.createdDate,  // Conditionally set CreatedDate
      ModifiedBy: childdata.Id === 0 ? userId : childdata.ModifiedBy,
      ModifiedDate: childdata.Id === 0 ? new Date() : childdata.ModifiedDate,
      IsActive: childdata.status1,
    }));
    const InteractAndRoteractClubDatasList1 = [
      ...InteractAndRoteractClubDatas1,
      ...RoteractClubDatas1
    ];
    const BranchAndChilds = {
      BranchData: branch,
      ChapterOfficialsData: childdata,
      InteractAndRoteractClubDatasList: InteractAndRoteractClubDatasList1,
    };

    try {


      const response = await updateData('BranchApi', id, BranchAndChilds, token);
      //const response = await postData('BranchApi', branch, token);
      console.log('Branch Updated success:', response);
      setSuccessMessage("Branch  Updated successfully!");
      setErrorMessage("");
      clearForm();


      setTimeout(() => {
        setSuccessMessage("");




      }, 3000);
      window.location.reload();

    } catch (error) {
      console.error('Branch Create error:', error);
    }
  };
  const toggleModalEdit = () => {
    setIsModalOpenEdit(prev => !prev);
    if (isModalOpenEdit) {
      resetForm(); // Only reset when modal is closing, not opening
      setEditData(null);
      setIsEditing(false);
      setClubsModalOpen(false);

    }
  };

  useEffect(() => {


    fetchTableDataBranch();
  }, [id, isAuthenticated, token, userId, logout]);
  const handleChange1 = (selectedOption) => {
    SetSelectedAssociate(selectedOption); // Get selected value
    if (selectedOption.value === 1) {
      setIsBank(true);
    }
    else {
      setIsBank(false);
    }
  };

  const resetForm = () => {
    setPersonName('');
    setOpening('');
    setBranch('');
    setAddress('');

    setPhonenumber('');
    setAccountNo('');
    setIFSC('');
    setEmail('');
    setSelectedValue('1');
    setIsBank(false);
  };

  const fetchTableDataBranch = async () => {
    try {
      const response = await fetchData('BranchApi', `/data/${id}`, token);

      if (response.responseCode === '1111') {
        const chapterdata = response.response_data.branchData || {};
        const chapterofficialsdata = response.response_data.chapterOfficialsData || [];
        const Interactandroteractclubsdata = response.response_data.interactAndRoteractClubDatasList || [];

        // **Filter out duplicate entries based on id**
        const uniqueOfficials = Array.from(
          new Map(chapterofficialsdata.map(item => [item.id, item])).values()
        );

        const Interactclubsdata = Interactandroteractclubsdata.filter(club => club.isInteract === true);
        const Roteractclubsdata = Interactandroteractclubsdata.filter(club => club.isInteract === false);

        setFormData({
          ...chapterdata,
          UpdatedBy: userId,
        });

        setClubChildDatas(uniqueOfficials);  // Set only unique officials
        setInteractClubDatas(Interactclubsdata);
        setRoteractClubDatas(Roteractclubsdata);
      } else {
        console.error('Unexpected response code:', response.responseCode);
      }
    } catch (error) {
      console.error('Error fetching Persons Details:', error);

      if (error.response && error.response.status === 401) {
        logout();
        history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
      }
    }
  };

  const handleFormSubmitEdit = async () => { // Mark the function as async
    if (isEditing && editData) {
      // Update the existing person

      const persondata = {
        Id: editData.id,
        Name: name,
        Opening: opening || 0,
        Address: address || "",
        Branch: isBank ? branch : "",
        AccountNo: isBank ? accountno : "",
        IFSC: isBank ? ifsc : "",
        Email: email1 || "",
        PhoneNumber: phone || "",
        PaymentType: selectedValue.value,
        ClubId: clubId || "",
        AssociateTypeId: selectedassociate.value || "",
        ModifiedBy: userId || "",
        ModifiedDate: new Date(),
        IsBank: isBank,
      };

      try {
        const response = await updateData('PersonApi', editData.id, persondata, token); // Use editData.id instead of id
        console.log('Record updated successfully:', response);

        // Optional: Show a success message, then clear it after 3 seconds
        setSuccessMessage("Record updated successfully!");
        toggleCluModalClose();
        //window.location.reload();
        setTimeout(() => {
          setSuccessMessage("");
        }, 3000);
      } catch (error) {
        console.error('Error updating record:', error);
      }
    }
  };

  const handleDelete = async (id, type) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this record?");
    if (!confirmDelete) return;
    if (id === 0) {
      // Remove locally based on type
      if (type === 1) {
        setClubChildDatas((prevData) => prevData.filter((data) => data.id !== 0));
      } else if (type === 2) {
        setInteractClubDatas((prevData) => prevData.filter((data) => data.id !== 0));
      } else if (type === 3) {
        setRoteractClubDatas((prevData) => prevData.filter((data) => data.id !== 0));
      }
    } else {
      try {
        // Call API to delete from database
        const response = await deleteData1('BranchApi', `${id}`, type, token);
        fetchTableDataBranch ();//window.location.reload();
        if (response.ok) {
          // Remove from state only if successfully deleted from DB
          if (type === 1) {
            setClubChildDatas((prevData) => prevData.filter((data) => data.id !== id));
          } else if (type === 2) {
            setInteractClubDatas((prevData) => prevData.filter((data) => data.id !== id));
          } else if (type === 3) {
            setRoteractClubDatas((prevData) => prevData.filter((data) => data.id !== id));
          }
        } else {
          console.error(`Failed to delete data of type ${type}`);
        }
      } catch (error) {
        console.error(`Error deleting record of type ${type}:`, error);
      }
    }
  };




  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Update gender based on the selected value
    }));
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return ''; // Handle cases where dateString is undefined or null
    const currentDate = new Date(dateString);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setPage(0); // Reset to the first page when changing rows per page
  };
  const handleChangePage1 = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage1 = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setPage(0); // Reset to the first page when changing rows per page
  };
  const handleChangePage2 = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage2 = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setPage(0); // Reset to the first page when changing rows per page
  };


  const filteredData = data;


  const paginatedData = ClubChildDatas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const paginatedData1 = InteractClubDatas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const paginatedData2 = RoteractClubDatas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const filteredByIsBank = filteredData.filter(item => item.isBank === false && (item.associateTypeId === 3 || item.associateTypeId === 4));
  const sortedData = stableSort(filteredByIsBank, getComparator(order, orderBy));

  return (
    <Fragment>
      <div>
        <div className="w-full max-w-sm container mt-2 mx-auto">

          <div className="w-full flex justify-between items-center flex-wrap">
            {/* Heading on the left */}
            <h6 className='productHead linkcolor'
              style={{ color: '#0e728c', padding: '7px', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
              CLUB EDIT
            </h6>

            <button
              onClick={toggleClubOfficialsModal}
              className="ml-3 text-blue-600 underline cursor-pointer"
              style={{
                background: 'none',
                border: 'none',
                fontSize: '14px',
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
            >
              CLUB OFFICIALS
            </button>


            {/* <button
              onClick={toggleInteractModal1}
              className="ml-3 text-blue-600 underline cursor-pointer"
              style={{
                background: 'none',
                border: 'none',
                fontSize: '14px',
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
            >
              INTERACT CLUBS
            </button>

            <button
              onClick={toggleRoteractModal1}
              className="ml-3 text-blue-600 underline cursor-pointer"
              style={{
                background: 'none',
                border: 'none',
                fontSize: '14px',
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
            >
              ROTARACT CLUBS
            </button> */}

            <button
              onClick={toggleClubsModal1}
              className="ml-3 text-blue-600 underline cursor-pointer"
              style={{
                background: 'none',
                border: 'none',
                fontSize: '14px',
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
            >
              CLUB LIST
            </button>




            {/* Buttons on the right */}
            <div className="flex mt-2">
              {/* <Button onClick={handleFormSubmit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#0e728c' }}>
                                UPDATE
                            </Button> */}
              <Button
                style={{
                  backgroundColor: '#5DB996',
                  color: 'white',
                  height: '36px',
                  marginTop: '15px'


                }}
                onClick={handleFormSubmit}
                className="linkcolor"
              >
                <span>Update</span>
              </Button>


              <Button
                className="linkcolor"
                onClick={() => history.push('/BIndex')}


                style={{
                  backgroundColor: '#FF748B',
                  color: 'white',
                  height: '36px',
                  marginTop: '15px',
                  marginLeft: '5px'
                }}>
                CANCEL
              </Button>
            </div>
          </div>
          <br></br>
          {errorMessage && <p className="text-red-500">{errorMessage}</p>}
          {successMessage && <p className="text-green-500">{successMessage}</p>}

          <div className="w-full flex flex-wrap">
            <div className="w-full sm:w-5/5 p-6 bg-white rounded-lg shadow-lg" style={{ width: '100%' }}>
              <div className="w-full grid grid-cols-4 gap-2">
                <div>
                  <label htmlFor="idno">ID No</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    name="idNo"
                    value={formData.idNo}
                    onChange={handleChange}
                    type="text"
                    placeholder="Enter Branch Id"
                    readOnly
                  />
                </div>
                <div>
                  <label htmlFor="branchcode">Code</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    name="branchCode"
                    value={formData.branchCode}
                    onChange={handleChange}
                    type="text"
                    placeholder="Enter Branch Code"
                    readOnly
                  />
                </div>
                <div>
                  <label htmlFor="branchname">Name</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    type="text"
                    placeholder="Enter Branch Name"
                  />
                </div>
                <div>
                  <label htmlFor="district">RI District</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    name="district"
                    value={formData.district}
                    onChange={handleChange}
                    type="text"
                    placeholder="Enter district"
                  />
                </div>
              </div>
              <div className="w-full grid grid-cols-4 gap-2">
                <div>
                  <label htmlFor="admittedDate">Date
                    <span className="text-red-500 ml-1">*</span>
                  </label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                    name="charterDate"
                    value={formatDateForInput(formData.charterDate)}
                    onChange={handleChange}
                    type="date"
                    placeholder="Enter Charterdate"

                  />
                </div>



                <div>
                  <label htmlFor="location">Location</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    type="text"
                    placeholder="Enter Branch location"
                  />
                </div>
                <div>
                  <label htmlFor="meetingday" className="text-sm font-medium">Meeting Day</label>
                  <select
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    name="meetingDay1"
                    value={formData.meetingDay1}
                    onChange={handleChange}
                  >
                    <option value="">Select a Day</option>
                    <option value="Sunday">Sunday</option>
                    <option value="Monday">Monday</option>
                    <option value="Tuesday">Tuesday</option>
                    <option value="Wednesday">Wednesday</option>
                    <option value="Thursday">Thursday</option>
                    <option value="Friday">Friday</option>
                    <option value="Saturday">Saturday</option>
                  </select>
                </div>



                <div>
                  <label htmlFor="meetingloc">Meeting Location</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    name="meetingLoc"
                    value={formData.meetingLoc}
                    onChange={handleChange}
                    type="text"
                    placeholder="Enter Meetingloc"
                  />
                </div>
              </div>
              <div className="w-full grid grid-cols-4 gap-2">
                <div>
                  <label htmlFor="meetingtime">Meeting Time</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    name="actualMeetingTime"
                    value={formData.actualMeetingTime || ""}  // Ensure it's an empty string if undefined
                    onChange={(e) => setFormData({ ...formData, actualMeetingTime: e.target.value })}
                    type="time"  // 'time' picker will send the format as HH:mm
                    placeholder="Select Meeting Time"
                  />
                </div>
                <div>
                  <label htmlFor="email">Email</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    type="text"
                    placeholder="Enter Email"
                  />
                </div>
                <div>
                  <label htmlFor="postaladdress">Postal Address</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    name="postalAddress"
                    value={formData.postalAddress}
                    onChange={handleChange}
                    type="text"
                    placeholder="Enter Postal Address"
                  />
                </div>
                <div>
                  <label htmlFor="website">Website</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    name="website"
                    value={formData.website}
                    onChange={handleChange}
                    type="text"
                    placeholder="Enter Website"
                  />
                </div>
              </div>

              <div className="w-full grid grid-cols-4 gap-2">
                <div>
                  <label htmlFor="instalink">Insta Page</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    name="instaLink"
                    value={formData.instaLink}
                    onChange={handleChange}
                    type="text"
                    placeholder="Enter Insta Link"
                  />
                </div>
                <div>
                  <label htmlFor="facebooklink">Facebook Page</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    name="faceBookLink"
                    value={formData.faceBookLink}
                    onChange={handleChange}
                    type="text"
                    placeholder="Enter Facebook Link"
                  />
                </div>
                <div>
                  <label htmlFor="sponsoredclub">Sponsored Club</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    name="sposoredClubName"
                    value={formData.sposoredClubName}
                    onChange={handleChange}
                    type="text"
                    placeholder="Enter Sponsored Club"
                  />
                </div>
                <div>
                  <label htmlFor="sponsoredby">Sponsored by this Club</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    name="sponsoredBy"
                    value={formData.sponsoredBy}
                    onChange={handleChange}
                    type="text"
                    placeholder="Enter Sponsored by Club"
                  />
                </div>
              </div>
              <div className="w-full grid grid-cols-4 gap-2">
                <div>
                  <label htmlFor="cashopening">Cash Opening</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                    name="cashOpening"
                    value={formData.cashOpening}
                    onChange={handleChange}
                    type="text"
                    placeholder="Enter Cash Opening"
                  />
                </div>
              </div>
            </div>
          </div>
        </div >

        <Modal open={officialsModalOpen} onClose={() => setOfficialsModalOpen(false)}>
          <div className="fixed inset-0 flex items-center justify-center z-90">
            <div className="bg-white p-6 rounded-lg  w-full sm:w-4/5" style={{ maxHeight: '90vh', overflowY: 'auto', overflow: 'visible' }}>
              <div className="w-full mb-4 flex">
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                      <TableRow>
                        <TableCell colSpan={6} sx={{ borderBottom: '1px solid #ddd', color: '#0e728c', textAlign: 'center', padding: '2px', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>
                          Club Officials
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '7px' }}>Sl No</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd' }}>Positions</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd' }}>Member</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd' }}>Phone No</TableCell>
                       
                        <TableCell sx={{ borderBottom: '1px solid #ddd' }}>From Date</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd' }}>To Date</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                          <IconButton onClick={toggleModal} aria-label="add">
                            <AddIcon />
                          </IconButton>
                          <IconButton onClick={() => setOfficialsModalOpen(false)} aria-label="close" style={{ backgroundColor: '#f0f0f0', borderRadius: '50%' }}>
                            <CloseIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {paginatedData.map((childdata, index) => (
                        <TableRow key={index}>
                          <TableCell sx={{ borderBottom: '1px solid #ddd' }}>{index + 1}</TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #ddd' }}>
                            {positionlist.find((option) => option.value === childdata.userTypeId)?.label}</TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #ddd' }}>
                            {(childdata.memberName)}</TableCell>
                             <TableCell sx={{ borderBottom: '1px solid #ddd' }}>
                            {(childdata.phoneNo)}</TableCell>
                            
                          <TableCell sx={{ borderBottom: '1px solid #ddd' }}>
                            {formatDateForInput(childdata.fromDate)} {/* Ensure date formatting */}</TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #ddd' }}>
                            {formatDateForInput(childdata.toDate)} {/* Ensure date formatting */}</TableCell>
                          <TableCell sx={{ height: '40px', padding: '5px', textAlign: 'center' }}>
                            <IconButton onClick={() => toggleModal(childdata)}>
                              <EditIcon style={{ fontSize: '20px', color: 'blue' }} />
                            </IconButton>
                            <IconButton onClick={() => handleDelete(childdata.id, 1)}> {/* 1 = Club Officials*/}
                              <DeleteIcon style={{ fontSize: '20px', color: 'red' }} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>

                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 15]}
                    component="div"
                    count={ClubChildDatas.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    sx={{
                      '& .MuiTablePagination-toolbar': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'nowrap', // Ensures everything stays in one line
                        minHeight: '40px', // Keeps a proper height
                      },
                      '& .MuiTablePagination-selectLabel': {
                        marginBottom: 0, // Fixes label misalignment
                      },
                      '& .MuiTablePagination-displayedRows': {
                        marginBottom: 0, // Fixes row count misalignment
                      },
                    }}
                  />

                </TableContainer>
              </div>
            </div>
          </div>
        </Modal>






        <Modal open={interactModalOpen} onClose={() => setInteractModalOpen(false)}>
          <div className="fixed inset-0 flex items-center justify-center z-70">
            <div className="bg-white p-6 rounded-lg  w-full sm:w-1/2" style={{ maxHeight: '90vh', overflowY: 'auto', overflow: 'visible' }}>
              <div className="w-full mb-4 flex" style={{ width: '100%' }}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                      <TableRow>
                        <TableCell colSpan={6} sx={{ borderBottom: '1px solid #ddd', color: '#0e728c', textAlign: 'center', padding: '2px', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>
                          Add Interact Clubs
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px', width: '2%' }}>Sl No</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px', width: '20%' }}>Name</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px', width: '56%' }}>Address</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', padding: '2px', width: '12%' }}>
                          <IconButton onClick={toggleInteractModal} aria-label="add">
                            <AddIcon style={{ fontSize: '15px' }} />
                          </IconButton>
                          <IconButton onClick={() => setInteractModalOpen(false)} aria-label="close" style={{ backgroundColor: '#f0f0f0', borderRadius: '50%' }}>
                            <CloseIcon style={{ fontSize: '15px' }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {paginatedData1.map((childdata, index) => (
                        <TableRow key={index}>

                          <TableCell sx={{ borderBottom: '1px solid #ddd', width: '2%' }}>{index + 1}</TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #ddd', width: '20%' }}> {childdata.name} </TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px', width: '56%' }}>{childdata.address}</TableCell>
                          <TableCell sx={{ height: '40px', padding: '5px', textAlign: 'center', width: '12%' }}>
                            <IconButton onClick={() => toggleInteractModal(childdata)}>
                              <EditIcon style={{ fontSize: '15px', color: 'blue' }} />
                            </IconButton>

                            <IconButton onClick={() => handleDelete(childdata.id, 2)}> {/* 2 = Interact */}
                              <DeleteIcon style={{ fontSize: '15px', color: 'red' }} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 15]}
                    component="div"
                    count={InteractClubDatas.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage1}
                    onRowsPerPageChange={handleChangeRowsPerPage1}
                    sx={{
                      '& .MuiTablePagination-toolbar': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'nowrap', // Ensures everything stays in one line
                        minHeight: '40px', // Keeps a proper height
                      },
                      '& .MuiTablePagination-selectLabel': {
                        marginBottom: 0, // Fixes label misalignment
                      },
                      '& .MuiTablePagination-displayedRows': {
                        marginBottom: 0, // Fixes row count misalignment
                      },
                    }}
                  />

                </TableContainer>

              </div>
            </div>
          </div>
        </Modal>

        <Modal open={rotaractModalOpen} onClose={() => setRotaractModalOpen(false)}>
          <div className="fixed inset-0 flex items-center justify-center z-70">
            <div className="bg-white p-6 rounded-lg  w-full sm:w-3/5" style={{ maxHeight: '90vh', overflowY: 'auto', overflow: 'visible' }}>
              <div className="w-full mb-4 flex" style={{ width: '100%' }}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                      <TableRow>
                        <TableCell colSpan={6} sx={{ borderBottom: '1px solid #ddd', color: '#0e728c', textAlign: 'center', padding: '2px', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>
                          Add Rotaract Clubs
                        </TableCell>

                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px', width: '2%' }}>Sl No</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px', width: '20%' }}>Name</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px', width: '56%' }}>Address</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', padding: '2px', width: '12%' }}>
                          <IconButton onClick={toggleRoteractModal} aria-label="add">
                            <AddIcon style={{ fontSize: '15px' }} />
                          </IconButton>
                          <IconButton onClick={() => setRotaractModalOpen(false)} aria-label="close" style={{ backgroundColor: '#f0f0f0', borderRadius: '50%', width: '8%' }}>
                            <CloseIcon style={{ fontSize: '15px' }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {paginatedData2.map((childdata, index) => (
                        <TableRow key={index}>

                          <TableCell sx={{ borderBottom: '1px solid #ddd', width: '2%' }}>{index + 1}</TableCell>

                          <TableCell sx={{ borderBottom: '1px solid #ddd', width: '20%' }}>{childdata.name}</TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #ddd', width: '56%' }}>{childdata.address}</TableCell>
                          <TableCell sx={{ height: '40px', padding: '5px', textAlign: 'center', width: '12%' }}>
                            <IconButton onClick={() => toggleRoteractModal(childdata)}>
                              <EditIcon style={{ fontSize: '20px', color: 'blue' }} />
                            </IconButton>
                            <IconButton onClick={() => handleDelete(childdata.id, 3)}> {/* 3 = Roteract */}
                              <DeleteIcon style={{ fontSize: '20px', color: 'red' }} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 15]}
                    component="div"
                    count={RoteractClubDatas.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage2}
                    onRowsPerPageChange={handleChangeRowsPerPage2}
                    sx={{
                      '& .MuiTablePagination-toolbar': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'nowrap', // Ensures everything stays in one line
                        minHeight: '40px', // Keeps a proper height
                      },
                      '& .MuiTablePagination-selectLabel': {
                        marginBottom: 0, // Fixes label misalignment
                      },
                      '& .MuiTablePagination-displayedRows': {
                        marginBottom: 0, // Fixes row count misalignment
                      },
                    }}
                  />

                </TableContainer>
              </div>
            </div>
          </div>
        </Modal>

        {isModalOpen && (
          <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
            <div className="fixed inset-0 flex items-center justify-center z-50">
           <div className="bg-white p-6 rounded-lg w-full sm:w-2/3 max-h-[80vh] overflow-y-auto relative pb-6">

                {/* Top Section (Checkbox + Dropdowns) */}
                <div className="flex items-center space-x-4 mb-6">
                  {/* Active Checkbox (Unchanged) */}
                  {selectedRecord && (
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        id="isActive"
                        checked={isActive}
                        onChange={(e) => setIsActive(e.target.checked)}
                        className="mr-2"
                      />
                      <label htmlFor="isActive">Active</label>
                    </div>
                  )}


                  <div className="w-1/2 mr-2">
                    <label htmlFor="position" className="block text-sm font-medium text-gray-700">
                      Select Position
                    </label>
                    <Select
                      value={positionlist.find(option => option.value === newRecordData.userTypeId)}
                      onChange={handlePositionSelectChange}
                      options={positionlist}
                      placeholder="Select Position"
                      isSearchable
                      isDisabled={!!selectedRecord}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 })
                      }}
                    />
                  </div>

                  {/* Member Dropdown */}
                  <div className="w-1/2 mr-2">
                    <label htmlFor="member" className="block text-sm font-medium text-gray-700">
                      Select Member
                    </label>
                    {/* <Select
                      value={memberlist.find(option => option.value === newRecordData.memberId)}
                      onChange={handleMemberSelectChange}
                      options={memberlist}
                      placeholder="Select Member"
                      isSearchable
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 })
                      }}
                    /> */}

                    <input
                                type="text"
                                id="searchMember"
                                value={newRecordData.name}
                                readOnly={!!selectedRecord} 
                                onChange={handleSearchChange}
                                placeholder="Type to search members"
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            />


                             {ispersonModalOpen && (
                                <div className="fixed inset-0 flex items-center justify-center z-10">
                                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '800px', height: '490px', overflowY: 'auto' }}>
                                        <div className="flex justify-end">
                                            <button onClick={closeModal} className="text-red-500 font-bold">Close</button>
                                        </div>

                                      
                                        <table className="mt-4 w-full border border-gray-300" style={{ borderCollapse: 'collapse', marginTop: '-10px' }}>
                                            <thead sx={{ backgroundColor: '#14a3c7' }}>
                                                <tr>
                                                    <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>First Name</th>
                                                    <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>Last Name</th>
                                                    <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>Phone Number</th>
                                                    <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>Email</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {memberlist.map((member) => (
                                                    <tr
                                                        key={member.id}
                                                        onClick={() => handleRowClick(member)}
                                                        className="cursor-pointer hover:bg-gray-200"
                                                        style={{ borderBottom: '1px solid #ddd' }}
                                                    >
                                                        <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.firstName}</td>
                                                        <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.lastName}</td>
                                                        <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.phoneNumber}</td>
                                                        <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.email}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                  </div>
                </div>

                {/* Date Inputs (Same Row, with Spacing) */}
                <div className="flex space-x-6 mb-8">

                  {/* From Date */}
                  <div className="w-1/2 mr-2">
                    <label htmlFor="fromDate" className="block text-sm font-medium text-gray-700">
                      From Date
                    </label>
                    <input
                      className="border-2 border-gray-300 rounded w-full py-2 px-3 text-gray-700 focus:outline-none"
                      type="date"
                      name="fromDate"
                      value={newRecordData.fromDate ? newRecordData.fromDate.split('T')[0] : ''}
                      onChange={(e) => setNewRecordData({ ...newRecordData, fromDate: e.target.value })}
                    />
                  </div>

                  {/* To Date */}
                  <div className="w-1/2 mr-2">
                    <label htmlFor="toDate" className="block text-sm font-medium text-gray-700">
                      To Date
                    </label>
                    <input
                      className="border-2 border-gray-300 rounded w-full py-2 px-3 text-gray-700 focus:outline-none"
                      type="date"
                      name="toDate"
                      value={newRecordData.toDate ? newRecordData.toDate.split('T')[0] : ''}
                      onChange={(e) => setNewRecordData({ ...newRecordData, toDate: e.target.value })}
                    />
                  </div>
                </div>




                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
                  <Button
                    style={{ backgroundColor: '#22c55e', color: 'white', padding: '8px 16px', borderRadius: '4px' }}
                    onClick={(e) => addOrEditRecord(e, selectedRecord ? 'edit' : 'add')}
                  >
                    {selectedRecord ? 'Edit Record' : 'Add Record'}
                  </Button>
                  <Button
                    style={{ backgroundColor: '#3b82f6', color: 'white', padding: '8px 16px', borderRadius: '4px', marginLeft: '8px' }}
                    onClick={() => setIsModalOpen(false)}
                  >
                    Cancel
                  </Button>
                </div>

              </div>
            </div>
          </Modal>
        )}







        {isModalOpen1 && (
          <Modal open={isModalOpen1} onClose={() => setIsModalOpen1(false)}>
            <div className="fixed inset-0 flex items-center justify-center z-50">
              <div className="bg-white p-6 rounded-lg  w-full sm:w-1/2" style={{ maxHeight: '90vh', overflowY: 'auto', position: 'relative' }}>
                <div className="w-full mb-4 flex">

                  <div className="w-full mb-4">
                    {/* First Row: Name & Checkbox at the End */}
                    <div className="flex flex-wrap items-center justify-between">
                      <div className="w-full sm:w-2/3 pr-2">
                        <label className="tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                          Name
                        </label>
                        <input
                          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                          type="text"
                          name="name"
                          placeholder="Enter Name"
                          value={newInteractData.name}
                          onChange={handleInputChange}
                        />
                      </div>

                      {/* Checkbox at the End of the Row */}
                      {selectedInteractRecord && (
                        <div className="w-auto flex items-center ml-auto">
                          <input
                            type="checkbox"
                            id="status1"
                            name="status1"
                            checked={newInteractData.status1 || false}
                            onChange={handleInputChange}
                            className="mr-2"
                          />
                          <label>Active</label>
                        </div>
                      )}
                    </div>

                    {/* Second Row: Address */}
                    <div className="w-full sm:w-2/3 pr-2">
                      <label className="tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="address">
                        Address
                      </label>
                      <textarea
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline resize-none"
                        name="address"
                        placeholder="Enter Address"
                        value={newInteractData.address || ""}
                        onChange={handleInputChange}
                        maxLength={250}
                        rows={3}
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        {newInteractData.address?.length || 0}/250 characters
                      </p>
                    </div>
                  </div>

                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-center', marginTop: '-5%' }}>
                  <Button
                    style={{ backgroundColor: '#22c55e', color: 'white', padding: '8px 16px', borderRadius: '4px' }}
                    onClick={addOrEditRecord1}
                  >
                    {selectedInteractRecord ? 'Edit Record' : 'Add Record'}
                  </Button>
                  <Button
                    style={{ backgroundColor: '#3b82f6', color: 'white', padding: '8px 16px', borderRadius: '4px', marginLeft: '8px' }}
                    onClick={() => setIsModalOpen1(false)}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </Modal>
        )}

        {isModalOpen2 && (
          <Modal open={isModalOpen2} onClose={() => setIsModalOpen2(false)}>
            <div className="fixed inset-0 flex items-center justify-center z-50">
              <div className="bg-white p-6 rounded-lg  w-full sm:w-1/2" style={{ maxHeight: '90vh', overflowY: 'auto', position: 'relative' }}>
                <div className="w-full mb-4 flex">

                  <div className="w-full mb-4">
                    {/* First Row: Name & Checkbox at the End */}
                    <div className="flex flex-wrap items-center justify-between">
                      <div className="w-full sm:w-2/3 pr-2">
                        <label className="tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                          Name
                        </label>
                        <input
                          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                          type="text"
                          name="name"
                          placeholder="Enter Name"
                          value={newRoteractData.name}
                          onChange={handleInputChange1}
                        />
                      </div>

                      {/* Checkbox at the End of the Row */}
                      {selectedRoteractRecord && (
                        <div className="w-auto flex items-center ml-auto">
                          <input
                            type="checkbox"
                            id="status1"
                            name="status1"
                            checked={newRoteractData.status1 || false}
                            onChange={handleInputChange1}
                            className="mr-2"
                          />
                          <label>Active</label>
                        </div>
                      )}
                    </div>

                    {/* Second Row: Address */}
                    <div className="w-full sm:w-2/3 pr-2">
                      <label className="tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="address">
                        Address
                      </label>
                      <textarea
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline resize-none"
                        name="address"
                        placeholder="Enter Address"
                        value={newRoteractData.address || ""}
                        onChange={handleInputChange1}
                        maxLength={250}
                        rows={3}
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        {newInteractData.address?.length || 0}/250 characters
                      </p>
                    </div>
                  </div>

                </div>

                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-center', marginTop: '-5%' }}>
                  <Button
                    style={{ backgroundColor: '#22c55e', color: 'white', padding: '8px 16px', borderRadius: '4px' }}
                    onClick={addOrEditRecord2}
                  >
                    {selectedRoteractRecord ? 'Edit Record' : 'Add Record'}
                  </Button>
                  <Button
                    style={{ backgroundColor: '#3b82f6', color: 'white', padding: '8px 16px', borderRadius: '4px', marginLeft: '8px' }}
                    onClick={() => setIsModalOpen2(false)}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </Modal>
        )}

        <Modal open={clubsModalOpen} onClose={() => setClubsModalOpen(false)}>
          <div className="fixed inset-0 flex items-center justify-center z-70">
            <div className="bg-white p-6 rounded-lg  w-full sm:w-3/5" style={{ maxHeight: '90vh', overflowY: 'auto', overflow: 'visible' }}>
              <div className="w-full mb-4 flex" style={{ width: '100%' }}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                      <TableRow>
                        <TableCell colSpan={6} sx={{ borderBottom: '1px solid #ddd', color: '#0e728c', textAlign: 'center', padding: '2px', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>
                          Interact / Roteract  Clubs
                        </TableCell>

                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px', width: '2%' }}>Sl No</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px', width: '20%' }}>Name</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px', width: '40%' }}>Address</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px', width: '18%' }}>Phone</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px', width: '15%' }}>Email</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px', width: '15%' }}>Type</TableCell>                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', padding: '2px', width: '8%' }}>
                          <IconButton onClick={() => setClubsModalOpen(false)} aria-label="close" style={{ backgroundColor: '#f0f0f0', borderRadius: '50%', width: '8%' }}>
                            <CloseIcon style={{ fontSize: '15px' }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody style={{ backgroundColor: '#F5F7F8' }}>
                      {sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((data, index) => (

                        <TableRow
                          key={data.id}
                          className={data.isActive ? '' : 'inactiveRow'}
                          sx={{
                            backgroundColor: index % 2 === 0 ? 'white' : '#ebf9fd',// Alternate row background colors
                          }}
                        >
                          <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>
                            {index + 1}
                          </TableCell>

                          <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>

                            {data.name && data.name.length > 25
                              ? `${data.name.slice(0, 25)}...`
                              : data.name}
                          </TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>
                            {data.address && data.address.length > 55
                              ? `${data.address.slice(0, 55)}...`
                              : data.address}
                          </TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>
                            {data.phoneNumber}
                          </TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>
                            {data.email}
                          </TableCell>

                          <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px' }}>
                             {data.associateTypeId === 3 ? "Interact" : "Roteract"}
                          </TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #D4E2D4', height: '20px', padding: '5px', textAlign: 'right', width: '15%' }}>
                            <Tooltip title="Edit Business Associates">
                              <Link to="#" onClick={() => handleEdit(data.id)}>
                                <IconButton>
                                  <EditIcon style={{ fontsize: '20px', color: 'blue' }} />
                                </IconButton>
                              </Link>
                            </Tooltip>

                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 15]}
                    component="div"
                    count={RoteractClubDatas.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage2}
                    onRowsPerPageChange={handleChangeRowsPerPage2}
                    sx={{
                      '& .MuiTablePagination-toolbar': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'nowrap', // Ensures everything stays in one line
                        minHeight: '40px', // Keeps a proper height
                      },
                      '& .MuiTablePagination-selectLabel': {
                        marginBottom: 0, // Fixes label misalignment
                      },
                      '& .MuiTablePagination-displayedRows': {
                        marginBottom: 0, // Fixes row count misalignment
                      },
                    }}
                  />

                </TableContainer>
              </div>
            </div>
          </div>
        </Modal>

        <Modal open={isModalOpenEdit} onClose={() => setIsModalOpenEdit(false)}>

          <div className="fixed inset-0 flex items-center justify-center z-90">
            <div className="bg-white p-6 rounded-lg  w-full sm:w-3/5" style={{ maxHeight: '90vh', overflowY: 'auto', overflow: 'visible' }}>
              <div className="w-full mb-4 flex" style={{ maxwidth: '100%' }}>
                <div className="w-1/4 mr-2">


                  <label className="tracking-wide text-black text-xs font-bold mb-2" htmlFor="parentgroup">Select Business Associate Type</label>
                  <Select
                    options={clubassociates}
                    value={selectedassociate}
                    //onChange={handleChange1}
                    onChange={() => { }} // No-op
                    isSearchable={false} // Disable search
                    menuIsOpen={false}

                    menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      control: (provided) => ({
                        ...provided,
                        width: "100%",
                        minWidth: 0, // allow shrinking
                        whiteSpace: "nowrap"
                      }),
                      menu: (provided) => ({
                        ...provided,
                        width: "100%",
                        minWidth: "200px",
                        whiteSpace: "nowrap",
                        overflowX: "auto", // Allows horizontal scrolling if needed
                        overflowY: "hidden", // Disables vertical scrolling
                        maxHeight: "none"
                      }),

                    }}
                  />

                </div>

                <div className="w-1/8 mr-2">

                  <label className="tracking-wide text-black text-xs font-bold mb-2" htmlFor="dropdown">Select Payment Type:</label>
                  <Select id="dropdown"
                    value={selectedValue}
                    onChange={() => { }} // No-op
                    isSearchable={false} // Disable search
                    menuIsOpen={false}
                    options={optionsn}
                  //onChange={handleChange}
                  />
                </div>

                <div className="w-1/2 mr-2">
                  <label className="tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">Name</label>
                  <input
                    className="border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={name}
                    onChange={(e) => setPersonName(e.target.value)}
                    type="text"
                    placeholder="Enter Person Name"
                  />
                </div>

              </div>

              {/* Form fields */}
              <div className="w-full mb-4 flex">


                <div className="w-1/8 mr-2">
                  <label htmlFor="opening" className="tracking-wide text-black text-xs font-bold mb-2">Opening</label>
                  <input
                    className="border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                    value={opening}
                    onChange={(e) => setOpening(e.target.value)}
                    type="text"
                    placeholder="Enter Opening"
                  />
                </div>


                <div className="w-1/2 mr-2">
                  <label htmlFor="branchOrAddress" className="tracking-wide text-black text-xs font-bold mb-2">Address</label>

                  <textarea
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    placeholder="Enter Address"
                    rows="1" // Optional: Adjusts the height of the textarea (number of rows)
                  />

                </div>

                <div className="w-1/10 mr-2">
                  <label htmlFor="branchOrAddress" className="tracking-wide text-black text-xs font-bold mb-2">Phone No</label>
                  <input
                    className="border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={phone}
                    onChange={(e) => setPhonenumber(e.target.value)}
                    type="text"
                    placeholder={"Enter Phone No"}
                  />
                </div>
                <div className="w-1/8 mr-2">
                  <label htmlFor="email" className="tracking-wide text-black text-xs font-bold mb-2">Email</label>
                  <input
                    className="border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={email1}
                    onChange={(e) => setEmail1(e.target.value)}
                    type="text"
                    placeholder="Enter Email"
                  />
                </div>
              </div>


              <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>

                <Button
                  component={Link}
                  onClick={handleFormSubmitEdit}
                  className="linkcolor"
                  style={{
                    color: 'whitesmoke', fontsize: '11px', backgroundColor: '#5DB996', height: '25px',
                    marginLeft: '5px'
                  }}
                >
                  Update
                </Button>
                <Button
                  component={Link}
                  onClick={toggleEditModalClose}
                  className="linkcolor"
                  style={{
                    color: 'whitesmoke', fontsize: '11px', backgroundColor: '#FF748B', height: '25px',
                    marginLeft: '5px'
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>

        </Modal>




      </div>
    </Fragment >
  );



  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }



}


export default BranchEdit;











